import Logo from "../../components/Logo";

const styles = {
  container:
    "w-[min(60rem,90%)] mx-auto px-6 py-12 font-sans text-gray-800 leading-relaxed",
  h1: "text-3xl font-bold mb-2 text-gray-900",
  h2: "text-xl font-semibold mt-10 mb-4 text-gray-900",
  p: "mb-4 text-base",
  updated: "text-sm text-gray-500 mb-8",
  ul: "list-disc pl-6 mb-4 space-y-2",
  li: "text-base",
  link: "text-blue-600 underline hover:text-blue-800",
};

export default function TermsOfService() {
  return (
    <div className="min-h-screen bg-white">
      <div className={styles.container}>
        <div className="mb-10">
          <Logo />
        </div>

        <h1 className={styles.h1}>Terms of Service</h1>
        <p className={styles.updated}>Effective Date: Feb 25, 2026</p>

        <h2 className={styles.h2}>1. Acceptance</h2>
        <p className={styles.p}>
          By using the Application, you agree to these Terms.
        </p>

        <h2 className={styles.h2}>2. Eligibility</h2>
        <p className={styles.p}>
          You must be at least 18 years old to use the Application.
        </p>

        <h2 className={styles.h2}>3. Account Registration</h2>
        <p className={styles.p}>
          You must provide accurate information and maintain the confidentiality
          of your account credentials.
        </p>

        <h2 className={styles.h2}>4. User Content</h2>
        <p className={styles.p}>
          Users are responsible for their content; however, the Company actively
          monitors, filters, and moderates content to enforce community safety.
        </p>
        <p className={styles.p}>You represent that:</p>
        <ul className={styles.ul}>
          <li className={styles.li}>You own the content;</li>
          <li className={styles.li}>You have necessary rights;</li>
          <li className={styles.li}>Your content does not violate any law.</li>
        </ul>

        <h2 className={styles.h2}>5. Prohibited Content</h2>
        <p className={styles.p}>
          You may not upload content that:
        </p>
        <ul className={styles.ul}>
          <li className={styles.li}>Is unlawful;</li>
          <li className={styles.li}>Is abusive or harassing;</li>
          <li className={styles.li}>Is hateful or discriminatory;</li>
          <li className={styles.li}>Contains sexually exploitative material;</li>
          <li className={styles.li}>Infringes intellectual property;</li>
          <li className={styles.li}>Promotes violence;</li>
          <li className={styles.li}>Constitutes fraud.</li>
        </ul>

        <h2 className={styles.h2}>6. Content Moderation and Enforcement</h2>
        <ul className={styles.ul}>
          <li className={styles.li}>Zero tolerance for objectionable content;</li>
          <li className={styles.li}>Users may report content;</li>
          <li className={styles.li}>Users may block other users;</li>
          <li className={styles.li}>Reports reviewed within 24 hours;</li>
          <li className={styles.li}>Company may remove content without notice;</li>
          <li className={styles.li}>Accounts may be suspended or permanently terminated;</li>
          <li className={styles.li}>Repeat offenders may be permanently banned;</li>
          <li className={styles.li}>
            Users may hide or remove content from their personal feed at any time;
          </li>
          <li className={styles.li}>
            Accounts engaging in harassment, abuse, or harmful behavior may be
            immediately suspended or permanently removed.
          </li>
        </ul>

        <h2 className={styles.h2}>7. User License Grant</h2>
        <p className={styles.p}>
          You grant The SHOW, LLC a worldwide, royalty-free, sublicensable
          license to use, display, reproduce, distribute, and promote your content.
        </p>

        <h2 className={styles.h2}>8. Intellectual Property</h2>
        <p className={styles.p}>
          All platform materials are owned by The SHOW, LLC.
        </p>

        <h2 className={styles.h2}>9. Disclaimer</h2>
        <p className={`${styles.p} uppercase font-semibold text-sm`}>
          THE APPLICATION IS PROVIDED "AS IS".
        </p>

        <h2 className={styles.h2}>10. Limitation of Liability</h2>
        <p className={styles.p}>
          To the maximum extent permitted by law, we are not liable for:
        </p>
        <ul className={styles.ul}>
          <li className={styles.li}>Indirect damages;</li>
          <li className={styles.li}>Lost profits;</li>
          <li className={styles.li}>Data loss;</li>
          <li className={styles.li}>Platform interruptions.</li>
        </ul>

        <h2 className={styles.h2}>11. Indemnification</h2>
        <p className={styles.p}>
          You agree to indemnify and hold harmless The SHOW, LLC from claims arising from:
        </p>
        <ul className={styles.ul}>
          <li className={styles.li}>Your content;</li>
          <li className={styles.li}>Your conduct;</li>
          <li className={styles.li}>Violation of these Terms.</li>
        </ul>

        <h2 className={styles.h2}>12. Termination</h2>
        <p className={styles.p}>
          We may suspend or terminate accounts at our discretion.
        </p>

        <h2 className={styles.h2}>13. Governing Law</h2>
        <p className={styles.p}>
          These Terms are governed by the laws of Delaware, United States.
        </p>

        <h2 className={styles.h2}>14. Questions</h2>
        <p className={styles.p}>
          Users who encounter inappropriate activity may contact support directly
          from within the Application.
        </p>
        <p className={styles.p}>
          If you have any questions about these Terms of Service, please contact us at{" "}
          <a href="mailto:support@theshowapp.com" className={styles.link}>
            support@theshowapp.com
          </a>.
        </p>
      </div>

      <footer className="border-t border-gray-200 py-8 text-center text-sm text-gray-500">
        © 2026 The SHOW, LLC. All rights reserved. —{" "}
        <a href="mailto:support@theshowapp.com" className={styles.link}>
          support@theshowapp.com
        </a>
      </footer>
    </div>
  );
}